import React from "react";
// plugin that creates slider
import Slider from "nouislider";
// @material-ui/core components
import { makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
// @material-ui/icons
import Paper from '@material-ui/core/Paper';
// core components
import NativeSelect from '@material-ui/core/NativeSelect';
import http from "../http";
import moment from "moment";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { useDropzone } from "react-dropzone";
import icon from "../assets/img/icon.png";
import Swal from 'sweetalert2'
import * as DocHelpers from "../Helpers/documentsHelper";


const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
  }
}))(LinearProgress);


const storage = http.prototype.getFirebaseStorage();

const styles = {
  textCenter: {
    textAlign: "center"
  },
  textMuted: {
    backgroundColor: "green"
  },
  tablehead: {
    backgroundColor:'#DD342F',
    color: 'white',
  },
  table:{
    color: 'white',
    fontSize:13,
    borderRight: '1px solid black'
  },
  table2:{
    color:'black',
    borderRight: '1px solid black'
  }

};
const musicDropStyle = {
  fontWeight: 'bold',
  border: 4,
  borderColor: 'ghostwhite',
  backgroundColor: 'rgb(35,48,79)',
  padding: 30,
  color:'ghostwhite'
}
const useStyles = makeStyles(styles);
const filesize = require('filesize');
export default function NewPolicy(props) {
 const [loading, setLoading] = React.useState(false);
 const classes = useStyles();
 const nth = function(d) {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1:  return "st";
    case 2:  return "nd";
    case 3:  return "rd";
    default: return "th";
  }
}


const fortnightAway = new Date();
const date = fortnightAway.getDate();
const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][fortnightAway.getMonth()];

 const [music, setMusic] = React.useState({
        fileSize:'',
        fileName:'',
        signedAt: 'Nrand Website',
        sgnedDay: date + nth(date),
        signedmonth: month+' '+fortnightAway.getFullYear(),
        paymentMethod: '',
        canAfford: '',
        signedName: '',
        signedId:'',
        signature: '',
        bankName: '',
        bankBranch:'',
        bankHolder:'',
        bankAccount:'',
        bankCode:'',
        bankType:'',
        debitDate: '',
        debitMonth: '',
        debitAmount: '',
        premium: '',
        title: '',
        entryDate: '01/MM/YYYY',
        benIdNumber:'',
        benName:'',
        communicationLanguage:'',
        address: '',
        phone: '',
        email:'',
        age:'',
        dateOfBirth:'',
        idNumber:'',
        surname:'',
        firstname:'',


 });
 const [newBeneficiary, setBeneficiary] = React.useState({
   name: '',
   idNo: '',
   age:'',
   relationship:'',
   fullBenefits: '',
 })
 const [musicImage, setMusicImage] = React.useState({});
 const [image, setImage] = React.useState('');
 const [file, setFile] = React.useState({});
 const [progress, setProgress] = React.useState(0);
 const [aploading, setAploading] = React.useState('');
 const [benList, setBenList] = React.useState([]);
 const [showAlert, setShowAlert] = React.useState(false);
 function getBase64(file) {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
      setImage(reader.result);
  };
  reader.onerror = function (error) {
  };
}
  
  const resetState =  () => {
   setBeneficiary({
    name: '',
    idNo: '',
    age:'',
    relationship:'',
    fullBenefits: '',
   })
  };

  
const canAcceptBeneficiary = () => {
  if(!newBeneficiary.name || !newBeneficiary.idNo || !newBeneficiary.age || !newBeneficiary.relationship){
   return false;
  }
  return true;
}
 const handleMusicChange = (key, value) => {
   const mus = {...music};
   mus[key] = value;
   if(key === 'idNumber' && value.length == 13 ){
    mus['dateOfBirth'] = DocHelpers.documentsHelper.getDateOfBirth(value);
    mus['age'] = DocHelpers.documentsHelper.getAge(value);
   }
   if((key === 'idNumber') && value.length > 13 ){
    return;
  }
  if(key === "entryDate" && !value.includes('01')){
    return;
  }

   setMusic(mus);
 }

 const handleBeneficiaryChange = (key, value) => {
  const mus = {...newBeneficiary};
  if(key === 'idNo' && value.length == 13 ){
    mus['age'] =  DocHelpers.documentsHelper.getAge(value);
   }
  mus[key] = value;
  setBeneficiary(mus);
}

function canBeSubmitted(){
  if(!music.phone || !music.idNumber || !music.surname || !music.firstname || music.idNumber.length < 10 ){
    return false;
  }
  return true;
}
//Document Builder 
function insertString(a, b, at)
{
    const length = at.length;
    var position = a.indexOf(at); 

    if (position !== -1)
    {
        position += length;
        return a.substr(0, position) +' '+ b + a.substr(position);    
    }  

    return a;
}
const list1Proto = "<tr><td></td> <td></td> <td></td> <td></td><td></td> </tr>";

const mainHTML =  `<!DOCTYPE html><html><head><title>Nrand</title><style>html{-webkit-print-color-adjust: exact;}body{width: 900px; padding-left: 40px; padding-right: 40px; font-family: Arial, Helvetica, sans-serif !important; font-size: 13px !important;}h4{text-align: center;}.sub-heading{text-align: center; color: rgb(221,52,47); font-weight: bolder;}.icon{width: 220px; height: 90px; margin-left: 70px;}.one{width: 200px; height: 25px; color: gray; margin-left: 70px; margin-top: 20px;}.text-center{text-align: center;}.span{color: rgb(221,52,47);}.spanline{padding-left: 5px; padding-right: 5px; border-bottom: 1px solid black;}.spandotted{padding-left: 5px; padding-right: 5px; border-bottom: 1px dotted black;}.two{color: gray; float: right; width: 480px; height: 40px;}.three{padding-left: 100px; padding-top: 20px;}.col1{background-color: rgb(221,52,47); width: 60%; height: 29px; color: white; padding-left: 5px; padding-top: 5px; border: 1px solid black;}.col2{background-color: rgb(221,52,47); width: 22%; height: 34px; color: white; border-right: 1px solid black; border-bottom: 1px solid black; border-top: 1px solid black;}.col3{background-color:rgb(221,52,47); width: 17%; height: 34px; border-bottom: 1px solid black; border-top: 1px solid black; border-right: 1px solid black;}.row1{display: flex;}.row2{display: flex}.col4{width: 65px; padding-left: 5px; padding-top: 5px; border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black;}.col5{width: 55px; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px;}.col6{width: 55px; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px}.col7{width: 50px; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px}.col8{width: 60px; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px}.col9{width: 539px; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px}.col10{width: 309px; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px}.col11{border-left: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black; padding-top: 5px; padding-left: 5px; width: 237px;}.row3{display: flex}.col12{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col13{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row4{display: flex}.col14{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col15{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row5{display: flex}.col16{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col17{border-bottom: 1px solid black; border-right: 1px solid black; width: 500px;}.col18{border-bottom: 1px solid black; border-right: 1px solid black; width: 60px; padding-left: 5px; padding-top: 5px}.col19{border-bottom: 1px solid black; border-right: 1px solid black; width: 535px;}.row6{display: flex}.col20{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col21{border-bottom: 1px solid black; border-right: 1px solid black; width: 500px;}.col22{border-bottom: 1px solid black; border-right: 1px solid black; width: 60px; padding-left: 5px; padding-top: 5px;}.col23{border-bottom: 1px solid black; border-right: 1px solid black; width: 535px;}.row7{display: flex}.col24{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col25{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row8{display: flex}.col26{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col27{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row9{display: flex}.col28{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col29{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row10{display: flex}.col30{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col31{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row11{display: flex}.col32{border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col33{border-bottom: 1px solid black; border-right: 1px solid black; width: 1102px;}.row12{display: flex;}.col34{border-left: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px; width: 309px;}.col35{border-bottom: 1px solid black; border-right: 1px solid black; width: 520px;}.col36{border-bottom: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px; width: 40px;}.col37{border-bottom: 1px solid black; border-right: 1px solid black; width: 535px;}.row13{display: flex;}.col38{border-bottom: 1px solid black; width: 309px; height: 21px; border-left: 1px solid black; border-right: 1px solid black; padding-left: 5px; padding-top: 5px;}.col39{border-bottom: 1px solid black; border-right: 1px solid black; height: 26px; width: 566px;}.col40{border-bottom: 1px solid black; border-right: 1px solid black; height: 26px; width: 535px;}.row14{height: 34px; width: 1412px; background-color: rgb(221,52,47); color : white; padding-left: 5px; padding-top: 5px; border-left: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;}th{height: 38px; background-color: rgb(221,52,47); color : white; border: 1px solid black;}.table1{margin-top: 20px; border-collapse: collapse;}td{border: 1px solid black; height: 20px;}.table2{border-collapse: collapse; height: 22px; width:250px;}#tick{background-color: white; color: rgb(221,52,47); width: 100px;}.tables{display: flex; justify-content: space-between;}.top{background-color: rgb(221,52,47); color: white; text-align: center; height: 42px; width: 350px;}.bottom{display: flex; justify-content: space-between; padding: 2px;}.bank-details{width:350px; border: 1px solid black;}.left{border-left: 1px solid black; border-bottom: 1px solid black; margin-left: 35px; width: 214px;}p{padding-left: 10px;}.premium{width: 250px;}.sign1{margin-top: 50px; display: flex;}.line{width: 130px; border-bottom: 1px solid gray; margin-left: 10px;}.sign2{padding-top: 60px;}.line2{width: 200px; border-bottom: 1px solid gray; margin-left: 100px;}.sign3{margin-top: 20px;}.sign4{margin-top: 20px;}.par{border: 1px solid black; width: 450px; height: 90px; position: absolute; left: 950px; bottom: -800px;}strong{color: rgb(5, 81, 110);}.add{border: 1px solid black; height: 110px; width: 720px; margin-top: 50px; color: gray;}.first{display: flex; margin-top: 30px; justify-content: start; margin-bottom: 20px;}.yes{height: 20px; width: 33px; margin-left: 80px; text-align: center; border: 1px solid black; margin-top: 10px;}.no{height: 20px; width: 30px; text-align: center; border-right: 1px solid black; border-bottom: 1px solid black; border-top: 1px solid black;}.declare{margin-bottom: 20px;}.bank-name{}.acc-no{padding-top: 20px;}.deduction{border-collapse: collapse; margin-top: 20px;}.authorise{margin-top: 20px;}.tables1{margin-bottom: 10px; border-collapse: collapse;}#name{background-color: rgba(211, 209, 209, 0.884); color: black;}.empty{display: flex; margin-left: 50px;}.nothing1{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 250px;}.nothing2{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 420px;}.nothing3{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 440px;}.nothing4{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 360px;}.nothing5{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 365px;}.nothing6{margin-left: 370px; margin-top: 10px;}.nothing7{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 410px;}.nothing8{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 440px;}.nothing9{width: 600px; border-bottom: 1px solid black; margin-bottom: 17px; margin-left: 535px;}.nothing10{margin-bottom: 17px; margin-left: 170px;}</style></head><body><h4>MEMBERSHIP APPLICATION</h4><p class="sub-heading">NRand Burial Service</p><div class="icon"><img alt="icon" width="170px" height="80px" src="https://firebasestorage.googleapis.com/v0/b/nrand-docs.appspot.com/o/NRAND_NEW_MOTTO-1-removebg-preview.png?alt=media&token=8f785dc1-7aff-4cc8-89b7-a079d8ff2103"/></div><div class="one">Your Grief <span class=".span">|</span> Our Concern</div><div class="two"><p>NRand Brokers cc - FSP No. 35408 is an Authorised Financial Service Provider. Terms and Condition apply.</p></div><div class="three"><p>FSP 35408</p></div><div class="row1"><div class="col1">Main Member Details</div><div class="col2"></div><div class="col3"></div></div><div class="row2"><div class="col4">Title:</div><div class="col5" id="title"></div><div class="col6"></div><div class="col7"></div><div class="col8"></div><div class="col9"></div><div class="col10">PREMIUM</div><div class="col11" id="premium"></div></div><div class="row3"><div class="col12">Surname:</div><div class="col13" id="surname"></div></div><div class="row4"><div class="col14">First Name:</div><div class="col15" id="firstname"></div></div><div class="row5"><div class="col16">ID No:</div><div class="col17" id="idNumber"></div><div class="col18">Age:</div><div class="col19" id="age"></div></div><div class="row6"><div class="col20">Date Of Birth:</div><div class="col21" id="dateOfBirth"></div><div class="col22"></div><div class="col23"></div></div><div class="row7"><div class="col24">Address:</div><div class="col25" id="address"></div></div><div class="row8"><div class="col26">Email Address:</div><div class="col27" id="email"></div></div><div class="row9"><div class="col28">Tel / Cell No:</div><div class="col29" id="phone"></div></div><div class="row10"><div class="col30">Preferred language of communication:</div><div class="col31" id="communicationLanguage"></div></div><div class="row11"><div class="col32">Entry date:</div><div class="col33" id="entryDate"></div></div><div class="row12"><div class="col34">Name of beneficiary & ID No:</div><div class="col35" id="benName"></div><div class="col36">ID:</div><div class="col37" id="benIdNumber"></div></div><table class="tables1"><thead><tr><th class="" width="588px">NAME AND SURNAME OF EXTENDED FAMILY</th><th width="300px">IDENTITY NUMBER / DATE OF BIRTH</th><th width="100px">AGE</th><th width="175px">RELATIONSHIP</th><th>Need full benefits</th></tr></thead><tbody id="list1"></tbody></table><div class="tables"><table class="table2"><thead><tr><th width="300px">PAYMENT METHOD</th><th class=" text-center" id="tick">TICK</th></tr></thead><tbody><tr><td id="paymentMethod"></td><td class=" text-center">X</td></tr></tbody></table><div class="bank-details"><div class="top">OUR BANK DETAILS</div><div class="bottom"><div class=""><p>Acc Name:</p><p>Bank:</p><p>Account No:</p><p>Branch Name:</p><p>Branch Code:</p><p>Your Ref</p></div><div class=""><p>NRand Funerals</p><p>First National Bank</p><p>62 6 49 72 61 90</p><p>Rosebank</p><p>253 305</p><p>Policy NUmber</p></div></div></div><div class="premium"><table class="table2"><thead><tr><th width="170px" style="border-right:1px solid rgb(221,52,47);">PREMIUM</th><th class="text-center" style="border-left: 1px solid rgb(221,52,47);" width="70px"></th></tr></thead><tbody><tr><td id="paymentMethod">TOTAL PREMIUM DUE</td><td class=" text-center" id="premium2"></td></tr></tbody></table></div></div><div class="sign1">Signed at <span class="spanline" id="signedAt"></span> on this <span class="spanline" id="sgnedDay"></span> day of <span class="spanline" id="signedmonth"></span></div><div class="sign2">SIGNATURE <span class="spanline" id="signature"></span></div><div class="sign3">NAME & SURNAME <span class="spanline" id="signedName"></span></div><div class="sign4">ID NO <span class="spanline" id="signedId"></span> </div><div class="add"><p>Head Office: Office 13, 3rd Floor Marble Towers, 208-212 Jeppe Street, Johannesburg</p><p>Thohoyandou: Office B3, Sabina Plaza, 93 Mphephu Drive l Louistrichardt: No 4. Ackerman Centre, Cnr. Rissik & Kruger Street</p><p>Reg No: 2008/099277/23 Tel: +27 11 974 7950 Fax: 086 6044 327 Email: <strong>info@nrandfunerals.co.za</strong></p></div><div class="first"><p>I CAN AFFORD PREMIUMS FOR THIS POLICY</p><div class="yes" id="canAfford"></div></div><div class="declare">I, THE PERSON MENTIONED AS THE MAIN MEMBER OF PREMIUM PAYER,HERE BY APPLY FOR MEMBERSHIP OF NRAND FOOD-ASSIST PLANS IN ACCORDANCE WITH THE TERMS AND CONDITIONS WHICH I HAVE READ AND UNDERSTOODNAS SET OUT HEREIN.I WISH TO PAY MY MONTHLY PREMIUMS AS FOLLOW:</div><div class="bank-name">Bank Name:<span class="spandotted" id="bankName"></span> Branch Name:<span class="spandotted" id="bankBranch"></span> Account Holder: <span class="spandotted" id="bankHolder"></span></div><div class="acc-no">Account No: <span class="spandotted" id="bankAccount"></span> Type of Account:<span class="spandotted" id="bankType"></span> Code:<span class="spandotted" id="bankCode"></span></div><div><table class="deduction"><tbody><tr><td width="350px">Deduction Date</td><td width="40px" id="debitDate"></td><td width="350px">Month: <span id="debitMonth"></span> </td></tr></tbody></table></div><div class="authorise"><p>I authorise NRand Brokers to debit my account on this day <span class="spanline" id="debitDate3"></span> of each month with the amount of <span class="spanline" id="debitAmount"></span> per month and additional R100 / R160 ONCE OFF FEE in the 1st month for administration purposes.Should the relevant premium be adjusted by the institution as a results of a general decreases/increases in premium. I confirm that the adjusted premium (including stamps duty) may be deducted from my bank acount. until such time as i cancel this authorisation in writing or until i substitute it with a new authorisation.</p><p>This signed Authority and Mandate refers to our contants as dated as on signature hereof{the Agreement}. I / We hereby authorise you to issue and deliver payment imstruction to the bank for collection against my/ our abovementionned acccount at my / our above mentioned bank{or any other bank or branch to which i / we may tranfer my / our account}on condition that the sum of such payment instruction will never exceed my / our obligations as agreed to in the agreement, and commencing on the commencement date and continuing until this Authority and Mandate is terminated by me / us by giving you notice in writting of no less than 20 ordinary working days, and sent by prepaid registered post or delivered to your address indicated above.</p><p>The individual payment instruction so authorised to be issued must be issued and delivered as follows:</p><p>I on the <span class="spanline" id="debitDate2"></span> day{"payment day"}of each and every month commencing on <span class="spanline" id="entryDate2"></span> in the event that the payment day falls on a Saturday, Sunday or recognized South African public holiday, the payment day will automatically be the very next ordinary business say.further, if there are insufficient funds in the nominated account to meet the obligation. you are entitled to track my account and re-present the instruction for payment as soon as sufficient funds are available in my account.</p><p>I. Monthly on or after the dates when the obligation in terms of §Agreement is due and the amount of each individual payment instruction may not be more or less that the obkigation due;</p><p>I / We understand that the withdrawal hereby authorised will be processeed through a computerized system providedby South african Banks and i also understand that details of each withdrawal will be printed on my bank statement.Each transction will contain a number,which must be included in the said payment instruction and if provided to you should enable you to identify the Agreement. A payment reference is sdded to this form before the issuing of any payment instruction. I / We shall not be entitled to any refund of amount which you have withdrawn while this Authority was in force, if such amount were legally owing to NRand Brokers.</p><h5>MANDATE</h5><p>I / We acknowledge that all payment instructions issued by you shall be treated by my / our aove mentioned bank as if the instructions had been issued by me/ us personally.</p><h5>CANCELLATION</h5><p>I / We agree that although this Authorityand Mandate may be cancelled by me / us, such cancellation will not cancel the Agrrement. I / We shall not be entitled to any refund of amounts which you have withdrawn while authority was in force, if such amounts were legally owing to you.</p><h5>ASSIGNMENT</h5><p>I / We acknowledge that this Authority may be ceded to or assigned to a third party if the agreement is also ceded or assigned to that third party,but in the absence of such assihnment of the agreement, this Authority and Mandate cannot be assigned to any third party.</p><p>Signed at <span class="spanline" id="signedAt2"></span> on this <span class="spanline" id="sgnedDay2"></span> day of <span class="spanline" id="signedmonth2"></span></p><p>SIGNATURE <span class="spanline" id="signature2"></span> (AS USED FOR SIGNING CHEQUES OR CREDIT CARD VOUCHERS)</p><p>NAME & SURNAME <span class="spanline" id="signedName2"></span> ID NO <span class="spanline" id="signedId2"></span> </p><h3 id="terms">GENERAL TERMS & CONDITIONS</h3><ol><li>Premiums are payable monthly in advance on or before the 1st day of each month. No premium received No cover.</li><li>In the event that payment was skipped by more than 15 days and later paid, you agree that such payment will be to save this policy from lapsing and that NRand will not entertain any claim you may submit, where death occurred during the month you paid for or within 30 days from the date in which outstanding premium was settled. In short, you will have 30 days waiting period each time you skip premium payment by more than 15 days.</li><li>Cover is subject to a once-off entry fee payable with your first instalment.</li><li>30 Days waiting period for added members on Plan A and 60 days on Plan B. No waiting period for the main member, provided he or she is the one who took the policy. In the event that this policy was taken on behalf of the main member without her or him being present, 30 days waiting period applies.</li><li>You are required to choose 5 members including main member who will receive full VIP package as detailed.</li><li>There will be no cover in the event of death which occurred before the waiting period expired. In the event that a pick up has been done, You will be responsible for pick up and storage fee as determined by the company.</li><li>Benefits for children under the age of 14 are different from adult members, i.e. Baby coffin, baby tombstone, no airtime, no grocery, no VIP Services,</li><li>NB: Please note that we only conduct burial services in and around Venda<ul><li>We do not mix our service with others, we conduct the whole funeral service, i.e. tombstone, coffin, flowers, etc.</li><li>You will be charged for grave construction.</li><li>You will be charged for repatriation of the body.</li><li>We reserve our rights not to provide service and to charge any applicable fee in the event of breach of terms & conditions above.</li><li>By accepting this burial book, you confirm that you are bound by the above terms and conditions which will be enforceable in the court of law.</li></ul></li></ol></div></body></html>`;
const getFinder = (id) => {return `id="${id}">`};
const getBeneficiaries = (benList2) => {
let ht = "";
benList2.map(e => {
  const list1Proto = "<tr><td>"+e.name+"</td> <td>"+e.idNo+"</td> <td>"+e.age+"</td> <td>"+e.relationship+"</td><td>"+(e.fullBenefits ? 'X': '')+"</td> </tr>";
  ht += list1Proto;
})
return ht;
}

const duplicates = {
  signedAt: ['signedAt2'],
  sgnedDay: ['sgnedDay2'],
  signedmonth: ['signedmonth2'],
  debitDate: ['debitDate3', 'debitDate2'],
  entryDate: ['entryDate2'],
  signedName:['signedName2'],
  signedId: ['signedId2'],
  signature: ['signature2'],
  premium: ['premium2'],


}

const generateHtml = React.useCallback(() => {
 let htmlFile = mainHTML;
 
 Object.keys(music)
 .map(key => {
   const value = music[key];
   const finder = getFinder(key);
    htmlFile = insertString(htmlFile, value ,finder) ;
    if(duplicates[key]){
      duplicates[key].map(key2 => {
        const finder2 = getFinder(key2);
        htmlFile = insertString(htmlFile, value ,finder2);
      })
    }
 })
 const beneficiaries =  getBeneficiaries(benList);
 const finder = getFinder('list1');
 htmlFile = insertString(htmlFile, beneficiaries ,finder);
 return http.prototype.addNewMusic({...music,file: htmlFile, createdAt: new Date()})
    .then(id => {
      Swal.fire({
        title: 'Thank You!',
        text: "Your Information is captured and we'll be in contact soon",
        icon: 'success'
      })
     setTimeout(()=> {
       window.location.href = 'https://nrandfunerals.co.za/'; 
     }, 3000);
     
    })
  
},[music, benList])



const addNewMusc = React.useCallback((music) => {
  let foundId = '';
  
},[]);

  return (
    <div >
    <Card classes={classes.textCenter} >
    <CardHeader color="primary" >New Membership - Burial Services</CardHeader>
    <CardBody>
    <Avatar src={icon} style={{width:170,height:80}} variant="square" />

    <Box width="100%" height={40}  style={{background: "linear-gradient(40deg, #DD342F, rgba(221,52,47,0.8))",marginTop:25, marginBottom:10,paddingTop:8,paddingLeft:5}} color="primary">
      <p  style={{color:'white',fontWeight:"bold", fontSize: 17}}>Main Member Details</p>
    </Box>
   
<GridContainer>
<GridItem xs={12} sm={12} md={5}>
<NativeSelect
color="primary"
style={{width:'100%',marginTop:26}}
value={music.title}
title="Title"
onChange={(event) => {
  handleMusicChange('title',event.target.value);
}}
inputProps={{
  name: 'Select Title',
  id: 'age-native-helper',
}}
>
<option defaultValue value="" >Select Title</option>
{['MS','MR', 'MRS', 'REV'].map(e => <option key={e} value={e} >{e}</option>)}
</NativeSelect>

</GridItem>
<GridItem xs={12} sm={12} md={5}>
<NativeSelect
color="primary"
style={{width:'100%',marginTop:26}}
value={music.premium}
onChange={(event) => {
  handleMusicChange('premium',event.target.value);
}}
inputProps={{
  name: 'Select Premium',
  id: 'age-native-helper',
}}
>
<option defaultValue value="" >Select Premium</option>
{['R100',
  'R160'].map(e => <option key={e} value={e} >{e}</option>)}
</NativeSelect>

</GridItem>

<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="First Name"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('firstname',event.target.value);
  },
  value: music.firstname
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Surname"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('surname',event.target.value);
  },
  value: music.surname
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="ID No"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('idNumber',event.target.value);
  },
  value: music.idNumber
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Date Of Birth"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('dateOfBirth',event.target.value);
  },
  value: music.dateOfBirth
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={1}>
<CustomInput
labelText="Age"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('age',event.target.value);
  },
  value: music.age
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Email address"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('email',event.target.value);
  },
  value: music.email
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Tel / Cell No"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('phone',event.target.value);
  },
  value: music.phone
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={10}>
<CustomInput
labelText="Address"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('address',event.target.value);
  },
  value: music.address
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Preferred language of communication"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('communicationLanguage',event.target.value);
  },
  value: music.communicationLanguage
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Entry Date"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('entryDate',event.target.value);
  },
  value: music.entryDate
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Name of beneficiary"
formControlProps={{
  fullWidth: true
}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('benName',event.target.value);
  },
  value: music.benName
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="Beneficiary ID no"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => {
   handleMusicChange('benIdNumber',event.target.value);
  },
  value: music.benIdNumber
}}
/>
</GridItem>
<GridItem xs={12} sm={12} md={12}>
<Box width="100%" height={40}  style={{background: "linear-gradient(40deg, #DD342F, rgba(221,52,47,0.8))",marginTop:25, marginBottom:10,paddingTop:8,paddingLeft:5}} color="primary">
      <p  style={{color:'white',fontWeight:"bold", fontSize: 17}}>Extended Family Details</p>
    </Box>
</GridItem>
<GridItem xs={12} sm={12} md={12}>
<p style={{color:"gray"}}>
Only a total of five members including main member will be entitled to claim full benefits. The remaining ten members will receive tombstone and coffin. Please ensure five members are selected.
</p>
</GridItem>

<GridItem xs={12} sm={12} md={10}>
  <TableContainer component={Paper}>
  <Table >
  <TableHead className={classes.tablehead}>
    <TableRow>
 <TableCell className={classes.table}>NAME & SURNAME OF EXTENDED FAMILY</TableCell>
 <TableCell className={classes.table}>IDENTITY NUMBER / DATE OF BIRTH</TableCell>
 <TableCell className={classes.table}>AGE</TableCell>
 <TableCell className={classes.table}>RELATIONSHIP</TableCell>
 <TableCell  className={classes.table} >Needs full benefits</TableCell>
 </TableRow>
  </TableHead>
  <TableBody>
   {benList.map((row,key) => <TableRow key={key}>
  <TableCell className={classes.table2}>{row.name}</TableCell>
 <TableCell className={classes.table2}>{row.idNo}</TableCell>
 <TableCell className={classes.table2}>{row.age}</TableCell>
 <TableCell className={classes.table2}>{row.relationship}</TableCell>
 <TableCell  className={classes.table2} >{row.fullBenefits ? 'Yes': 'No'}</TableCell>
   </TableRow>)}
  </TableBody>
</Table>
</TableContainer>
</GridItem>
<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="NAME & SURNAME"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange('name',event.target.value);
  },value: newBeneficiary.name
}} />
</GridItem>
<GridItem xs={12} sm={12} md={5}>
<CustomInput
labelText="ID NUMBER/DATE OF BIRTH"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange('idNo',event.target.value);
  },value: newBeneficiary.idNo
}} />
</GridItem>
<GridItem xs={12} sm={12} md={2}>
<CustomInput
labelText="Age"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange('age',event.target.value);
  },value: newBeneficiary.age
}} />
</GridItem>
<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Relationship"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleBeneficiaryChange('relationship',event.target.value);
  },value: newBeneficiary.relationship
}} />
</GridItem>
<GridItem xs={12} sm={12} md={4}>
{(benList.filter(e => e.fullBenefits == true)).length < 4 && <NativeSelect
color="primary"
style={{width:'100%',marginTop:26}}
value={newBeneficiary.fullBenefits}
onChange={(event) => {
  handleBeneficiaryChange('fullBenefits',(event.target.value === 'true' ? true : false))
}}
>
<option value={''} >Has Full Benefits?</option>
{[true,false].map(e => <option key={e} value={e} >{e ? 'Yes': 'No'}</option>)}
</NativeSelect>}
</GridItem>
<GridItem xs={12} sm={12} md={2}>
{benList.length < 14 &&  <Button 
style={{marginTop:18}}
disabled={!canAcceptBeneficiary()} onClick={()=> {
  const newben = benList.concat([newBeneficiary]);
  setBenList(newben);
  resetState();
}} color="primary">Add Member</Button>}
</GridItem>


<GridItem xs={12} sm={12} md={12}>
<Box width="100%" height={40}  style={{background: "linear-gradient(40deg, #DD342F, rgba(221,52,47,0.8))",marginTop:25, marginBottom:10,paddingTop:8,paddingLeft:5}} color="primary">
      <p  style={{color:'white',fontWeight:"bold", fontSize: 17}}>Declaration</p>
    </Box>
</GridItem>

<GridItem xs={12} sm={12} md={12}>
<p style={{color:"gray" ,fontWeight: 'light' , fontSize: 13}}>
OUR BANK DETAILS <br/> Acc Name: NRand Funerals. Bank: First National Bank. Account No: 62 649 726 190. Branch Name: Rosebank.   Branch Code: 253305.  Your Ref: Policy Number  
</p>
</GridItem>

<GridItem xs={12} sm={12} md={4}>
What is your Payment Method? 
<NativeSelect
color="primary"
style={{width:'100%',marginTop:7, marginBottom:20}}
value={music.paymentMethod}
onChange={(event) => {
  handleMusicChange('paymentMethod',(event.target.value))
}}
>
<option value={''} >Select Payment Method</option>
{["Sassa paying point","NRand Office", "Debit order","Cash deposit", "EFT"].map(e => <option key={e} value={e} >{e}</option>)}
</NativeSelect>
</GridItem>

<GridItem xs={12} sm={12} md={4}>
  Can you afford this Premium ? 
<NativeSelect
color="primary"
style={{width:'100%',marginTop:7, marginBottom:20}}
value={music.canAfford}
onChange={(event) => {
  handleMusicChange('canAfford',(event.target.value))
}}
>
<option value={''} >I CAN AFFORD PREMIUMS FOR THIS POLICY</option>
{["Yes","No"].map(e => <option key={e} value={e} >{e}</option>)}
</NativeSelect>
</GridItem>


<GridItem xs={12} sm={12} md={12}>
<p style={{color:"gray" , fontSize: 13}}>
Signed at <span style={{borderBottom:'2px solid gray', fontWeight: 'normal',paddingLeft:5,paddingRight:5}}>{music.signedAt}</span> on this <span style={{borderBottom:'2px solid gray', fontWeight: 'normal',paddingLeft:5,paddingRight:5}}>{music.sgnedDay}</span>  day of <span style={{borderBottom:'2px solid gray',  fontWeight: 'normal',paddingLeft:5,paddingRight:5}}>{music.signedmonth}</span>
</p>
</GridItem>

<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Signature/ initials and surname"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('signature',event.target.value);
  },value: music.signature
}} />
</GridItem>
<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Name & Surname"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('signedName',event.target.value);
  },value: music.signedName
}} />
</GridItem>
<GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="ID NO"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('signedId',event.target.value);
  },value: music.signedId
}} />
</GridItem>

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={10}>
<p style={{color:"gray" ,fontWeight: 'light' , fontSize: 13}}>
I, THE PERSON MENTIONED AS THE MAIN MEMBER OR PREMIUM PAYER, HEREBY APPLY FOR MEMBERSHIP OF NRAND BURIAL PLAN IN ACCORDANCE WITH THE TERMS AND CONDITIONS WHICH I HAVE READ AND UNDERSTOOD AS SET OUT HEREIN. I WISH TO PAY MY MONTHLY PREMIUMS AS FOLLOWS:
</p>
</GridItem>}

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Bank Name"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('bankName',event.target.value);
  },value: music.bankName
}} />
</GridItem>}
{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Branch Name"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('bankBranch',event.target.value);
  },value: music.bankBranch
}} />
</GridItem>}
{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={4}>
<CustomInput
labelText="Account Holder"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('bankHolder',event.target.value);
  },value: music.bankHolder
}} />
</GridItem>}

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Account No"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('bankAccount',event.target.value);
  },value: music.bankAccount
}} />
</GridItem>}
{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Type of Account"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('bankType',event.target.value);
  },value: music.bankType
}} />
</GridItem>}
{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={4}>
<CustomInput
labelText="Branch Code"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('bankCode',event.target.value);
  },value: music.bankCode
}} />
</GridItem>}

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={10}>
<p style={{color:"gray" ,fontWeight: 'light' , fontSize: 13}}>
I authorize NRand Brokers to debit my account on this <span style={{borderBottom:'2px solid gray', fontWeight: 'bolder', paddingLeft:5,paddingRight:5}}>{music.debitDate}</span> day of each month with the amount of R <span style={{borderBottom:'2px solid gray', fontWeight: 'bold',paddingLeft:5,paddingRight:5}}>{music.debitAmount}</span>  per month and additional {music.premium? music.premium : 'R100/ R160'} ONCE OFF FEE in the 1st month for administration purposes. Should the relevant premium be adjusted by the Institution as a result of a general decrease/increase in premium, I confirm that the adjusted premium (including stamps duty) may be deducted from my bank account, until such time as I cancel this authorisation in writing or until I substitute it with a new authorisation.
</p>
</GridItem>}

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
Deduction Date 
<NativeSelect
color="primary"
style={{width:'100%',marginTop:7, marginBottom:20}}
value={music.debitDate}
onChange={(event) => {
  handleMusicChange('debitDate',(event.target.value))
}}
>
<option value={''} >Select Date</option>
{["1st","7th","15th","25th","LDM"].map(e => <option key={e} value={e} >{e}</option>)}
</NativeSelect>
</GridItem>}

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
  Deduction Month
<NativeSelect
color="primary"
style={{width:'100%',marginTop:7, marginBottom:20}}
value={music.debitMonth}
onChange={(event) => {
  handleMusicChange('debitMonth',(event.target.value))
}}
>
<option value={''} >Select Month</option>
{["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map(e => <option key={e} value={e} >{e}</option>)}
</NativeSelect>
</GridItem>}

{music.paymentMethod === 'Debit order' && <GridItem xs={12} sm={12} md={3}>
<CustomInput
labelText="Enter Debit Amount"
formControlProps={{ fullWidth: true}}
inputProps={{
  onChange: (event) => { handleMusicChange('debitAmount',event.target.value);
  },value: music.debitAmount
}} />
</GridItem>}

<GridItem xs={12} sm={12} md={12}>
<Box width="100%" height={40}  style={{background: "linear-gradient(40deg, #DD342F, rgba(221,52,47,0.8))",marginTop:25, marginBottom:10,paddingTop:8,paddingLeft:5}} color="primary">
      <p  style={{color:'white',fontWeight:"bold", fontSize: 17}}>Agreement</p>
    </Box>
</GridItem>

{music.paymentMethod === 'Debit order' &&  <GridItem xs={12} sm={12} md={10}>
<p style={{color:"gray" ,fontWeight: 'light' , fontSize: 13}}>
This signed Authority and Mandate refers to our contract as dated as on signature hereof ("the Agreement"). I / We hereby authorise you to issue and deliver payment instructions to the bank for collection against my / our abovementioned account at my / our above mentioned bank (or any other bank or branch to which I / We may transfer my / our account) on condition that the sum of such payment instructions will never exceed my / our obligations as agreed to in the Agreement, and commencing on the commencement date and continuing until this Authority and Mandate is terminated by me / us by giving you notice in writing of no less than 20 ordinary working days, and sent by prepaid registered post or delivered to your address indicated above.<br/><br/>
The individual payment instructions so authorised to be issued must be issued and delivered as follows:<br/><br/>
I On the <span style={{borderBottom:'2px solid gray', fontWeight: 'bolder', paddingLeft:5,paddingRight:5}}>{music.debitDate}</span>  day ("payment day") of each and every month commencing on <span style={{borderBottom:'2px solid gray', fontWeight: 'bolder', paddingLeft:5,paddingRight:5}}>{music.entryDate}</span> . In the event that the payment day falls on a Saturday, Sunday or recognized South African public holiday, the payment day will automatically be the very next ordinary business day. Further, if there are insufficient funds in the nominated account to meet the obligation, you are entitled to track my account and re- present the instruction for payment as soon as sufficient funds are available in my account.
<br/><br/>ii. Monthly; on or after the dates when the obligation in terms of the Agreement is due and the amount of each individual payment instruction may not be more or less that the obligation due;
<br/><br/>I / We understand that the withdrawals hereby authorised will be processed through a computerized system provided by the South African Banks and I also understand that details of each withdrawal will be printed on my bank statement. Each transaction will contain a number, which must be included in the said payment instruction and if provided to you should enable you to identify the Agreement. A payment reference is added to this form before the issuing of any payment instruction. I / We shall not be entitled to any refund of amounts which you have withdrawn while this authority was in force, if such amounts were legally owing to NRand Brokers.
</p>
</GridItem>}

<GridItem xs={12} sm={12} md={10}>
<p style={{color:"gray" ,fontWeight: 'light' , fontSize: 13}}>
<br/><br/> MANDATE <br/> 
I / We acknowledge that all payment instructions issued by you shall be treated by my/our above mentioned bank as if the instructions had been issued by me/us personally.
<br/><br/> CANCELLATION  <br/> 
I / We agree that although this Authority and Mandate may be cancelled by me / us, such cancellation will not cancel the Agreement. I / We shall not be entitled to any refund of amounts which you have withdrawn while this authority was in force, if such amounts were legally owing to you.
<br/><br/> ASSIGNMENT  <br/> 
I / We acknowledge that this Authority may be ceded to or assigned to a third party if the agreement is also ceded or assigned to that third party, but in the absence of such assignment of the Agreement, this Authority and Mandate cannot be assigned to any third party.
</p>
</GridItem>

<GridItem xs={12} sm={12} md={10}>
<p style={{color:"gray" ,fontWeight: 'normal' , fontSize: 13}}>
<br/><br/> GENERAL TERMS & CONDITIONS <br/> <br/>
1. Premiums are payable monthly in advance on or before the 1st day of each month. No premium received No cover.<br/>
2. In the event that payment was skipped by more than 15 days and later paid, you agree that such payment will be to save this
policy from lapsing and that NRand will not entertain any claim you may submit, where death occurred during the month you
paid for or within 30 days from the date in which outstanding premium was settled. In short, you will have 30 days waiting
period each time you skip premium payment by more than 15 days.<br/>
3. Cover is subject to a once-off entry fee payable with your first instalment.<br/>
4. 30 Days waiting period for added members on Plan A and 60 days on Plan B. No waiting period for the main member, provided
he or she is the one who took the policy. In the event that this policy was taken on behalf of the main member without her or him
being present, 30 days waiting period applies.<br/>
5. You are required to choose 5 members including main member who will receive full VIP package as detailed.<br/>
6. There will be no cover in the event of death which occurred before the waiting period expired. In the event that a pick up has
been done, You will be responsible for pick up and storage fee as determined by the company.<br/>
7. Benefits for children under the age of 14 are different from adult members, i.e. Baby coffin, baby tombstone, no airtime, no
grocery, no VIP Services,<br/>
8.<span style={{fontWeight: 'bold'}}> NB: Please note that we only conduct burial services in and around Venda. </span><br/>
- We do not mix our service with others, we conduct the whole funeral service, i.e. tombstone, coffin, flowers, etc.<br/>
- You will be charged for grave construction.<br/>
- You will be charged for repatriation of the body.<br/>
- We reserve our rights not to provide service and to charge any applicable fee in the event of breach of terms & conditions above.<br/>
- By accepting our burial book, you confirm that you are bound by the above terms and conditions which will be enforceable in the
court of law.
</p>
</GridItem>


<GridItem xs={12} sm={12} md={12}>
<br />
{aploading && <h6>{aploading}</h6>}
{aploading && <BorderLinearProgress variant="determinate" color="primary" value={progress} />}

<br />
<Button disabled={!canBeSubmitted()} onClick={()=> {generateHtml()}} color="primary">Accept And Register</Button>
</GridItem>
<GridItem xs={12} sm={12} md={12}>
{canBeSubmitted() ?<p style={{color:"green"}}>
  You can now submit this form after reading and understainding our terms and conditions
</p>: <p style={{color:"red"}}>
Make sure all required fields are filled and correct before submitting <br/>
{!music.idNumber && <span>* ID Number  <br/></span>}
{!music.phone && <span>* Phone Number <br/></span>}
{(!music.firstname || !music.surname) && <span>* Name & Surname  <br/></span>}
{music.idNumber && music.idNumber.length < 10 && <span>* ID Number must be 13 digits long <br/></span>}
</p>}
</GridItem>
<GridItem xs={12} sm={12} md={12}>
<p style={{color:"gray"}}>
NRand Brokers cc - FSP No. 35408 is an Authorised Financial Services Provider. Terms and Conditions apply.
</p>
</GridItem>
</GridContainer>


    </CardBody>
  </Card>
      </div>
  );
}
